export default "__VITE_ASSET__CNOdp_DD__"